module.exports = __webpack_public_path__ + "static/media/2.c4a4c078.png";